import styled from 'styled-components';
import { Colors } from '~/config/Colors';
import Card from '~/pages/Sistema/componentes/Card';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;

  .content-vazio {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    .item-vazio {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-top: 2em;

      .title {
        margin-left: 1em;
        width: 14em;

        p {
          color: ${Colors.ft_color_11};
          font-size: 1em;
        }
      }
    }
  }
`;

export const ThisCard = styled.div`
  margin-bottom: 1.3em;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .card-info {
    padding: 0.6em;
    border-radius: 1em;
    background: #333233;
    display: flex;
    width: 100%;
    flex-direction: column;

    .card-top {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-bottom: 3em;

      .card-top-left {
        display: flex;
        margin-left: 1em;
        margin-top: 1em;
        flex-direction: row;

        .texts{
          margin-left: 20px;
          
          .titulo {
            font-size: 1em;
            width: 100%;
            font-weight: 800;
            color: #6796CF;
            margin-right: 0.75em;
          }

          .sub-titulo {
            font-size: 0.8em;
            width: 100%;
            font-weight: 600;
            color: #868585;
            margin-right: 0.75em;
          }
        }
      }

      .card-top-right {
        display: flex;
        margin-right: 1em;
        margin-top: 1em;
        flex-direction: column;

        .cod {
          font-size: 0.85em;
          width: 100%;
          font-weight: 800;
          color: ${Colors.Color4};
          margin-right: 0.75em;
        }
      }
    }
    
    .padding-form {
      padding: 0 1em 1em 1em;

      .row {
        margin-bottom: 0.5em;
  
        .point {
          max-width: 100%;
          height: 6em;
          border-radius: 0.6em;
          margin: auto;
          border: dashed #1A1A1A 0.125em;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 1em;

          
          .logo{
            display: flex;
            align-items: center;
            justify-content: center;

            .logo_img {
              width: 80%;
              height: 80%

            }
          }  
        }
      }

      .card-bottom {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-start;
        width: 100%;
        margin-top: 0.5em;
        margin-bottom: 1em;
    
        .card-grupo {
          background: ${Colors.Color8};
          border-radius: 0.4em;
          padding: 0.2em 0.6em;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          margin-top: 0.5em;
          margin-right: 0.5em;
          margin-bottom: 0.5em;
    
          .grupoperfil {
            font-size: 0.75em;
            font-weight: 800;
            color: ${Colors.Color4};
          }
        }
      }
    }    
  }
`;

export const ThisCardAnal = styled.div`
  margin-bottom: 1.3em;
  padding: 1.1em;
  border-radius: 1em;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 18em;
  height: 8em;
  position: relative;
  overflow: hidden;
  box-shadow: 0px 0px 20px rgba(174, 177, 200, 0.05) !important;
  background: ${Colors.Color1};
  margin-right: 1.5em;

  .card-bottom {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    width: 100%;
    margin-top: 0.5em;

    .card-grupo {
      background: ${Colors.Color8};
      border-radius: 0.4em;
      padding: 0.2em 0.6em;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-top: 0.5em;
      margin-right: 0.5em;
      margin-bottom: 0.5em;

      .grupoperfil {
        font-size: 0.65em;
        font-weight: 800;
        color: ${Colors.Color4};
      }
    }
  }

  .card-ativo {
    position: absolute;
    margin-left: 15em;
    margin-top: -1.55em;
  }

  .card-color {
    width: 3em;
    height: 3em;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-radius: 4em;
    background: ${props => (props?.cor ? '#' + props?.cor : Colors.Color4)};
  }

  .card-content{
    display: flex;

    .card-body {
      width: 100%;
      margin-right: 6em;

      .card-text {
        display: flex;
        flex-direction: column;

        .descricao {
          font-size: 0.66em;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          display: -webkit-box;
          overflow: hidden;
          font-weight: 800;
          color: ${Colors.Color4};
        }

        .titulo {
          font-size: 0.8em;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 95%;
          font-weight: 800;
          color: #8F9DAF;
      
        }
        
        .descricao-cord {
          font-size: 0.65em;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          display: -webkit-box;
          overflow: hidden;
          font-weight: 800;
          color: ${Colors.Color7};
        }
      
      .cor {
        font-size: 0.68em;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        display: -webkit-box;
        overflow: hidden;
        font-weight: 600;
        margin-top: 0.75em;
        color: ${Colors.Color4};
      }
    }
  }
`;